import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=a1cc33d0&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=ts"
export * from "./TeamCard.vue?vue&type=script&lang=ts"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=a1cc33d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc33d0",
  null
  
)

export default component.exports